var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-input",
    _vm._g(
      _vm._b(
        {
          directives: [
            {
              name: "mask",
              rawName: "v-mask",
              value: "######-####",
              expression: "'######-####'"
            }
          ],
          ref: "input"
        },
        "vue-input",
        _vm.$attrs,
        false
      ),
      _vm.$listerners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }